// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__37n9h","footer":"ReportModalFilter_footer__3wb7L"};